import React, { Component } from 'react';
import ReactSelector from './ReactSelector';
import { ValueType } from 'react-select/lib/types';
import axios from 'axios/axios-base';
import { showToastNotification } from 'store/ui/toasts/toastsActions';
import { ToastType } from 'store/ui/toasts/toastsTypes';
import { Tag } from 'types/rest/assetCatalogTypes';

interface TagSelectorProps {
  selectHandler?: (tags: Tag[]) => void;
  preSelected?: string[];
  menuPortalTarget?: HTMLElement;
  isReadOnly?: boolean;
  focus?: boolean;
}

interface OptionType {
  label: string;
  value?: number;
}

/**
 * Tag Selector based on Material UI component (react-select) https://react-select.com/home
 * The component fetches the tags from the back-end and displays them in an interactive dropdown.
 */

export default class TagSelector extends Component<TagSelectorProps> {
  state = {
    selectedTags: [],
    optionTypes: [],
    tags: [],
  };

  UNSAFE_componentWillMount() {
    // Fetch the tags from the back-end to pass them to the react-select component
    axios
      .get('/tags/?limit=-1&sort=name')
      .then(response => {
        const tags: Tag[] = response.data.result;
        if (tags !== undefined) {
          const optionTypes: OptionType[] = tags.map(tag => {
            return { label: tag.name, value: tag.id, key: tag.name };
          });

          this.setState({
            ...this.state,
            optionTypes: optionTypes,
          });

          if (this.props.preSelected !== undefined) {
            const preSelectedOptionTypes: OptionType[] = this.props.preSelected.map((str: string) => {
              return this.state.optionTypes.find((i: OptionType) => i.label === str);
            });
            this.setState({
              ...this.state,
              selectedTags: preSelectedOptionTypes,
            });
          }
        }
      })
      .catch(() => {
        showToastNotification(ToastType.Danger, 'Unable to fetch tags.');
      });
  }

  // Updates the state with the tags selected -- this.getSelectedTags is in the callback of this.setState to avoid synchronization issues
  handleUpdateTags = (value: ValueType<OptionType>) => {
    this.setState(
      {
        selectedTags: value,
      },
      () => {
        this.getSelectedTags();
      },
    );
  };

  // Maps OptionTypes retrieved from ReactSelectorCopy to Tag[]
  getSelectedTags = () => {
    if (this.state.selectedTags === null) {
      this.setState(
        {
          tags: [],
        },
        () => {
          if (this.props.selectHandler !== undefined) {
            this.props.selectHandler(this.state.tags);
          }
        },
      );
    } else {
      this.setState(
        {
          tags: this.state.selectedTags.map((optionType: OptionType) => {
            return { id: optionType.value, name: optionType.label };
          }),
        },
        () => {
          if (this.props.selectHandler !== undefined) {
            this.props.selectHandler(this.state.tags);
            const mappedTags = this.state.tags.map((tag: any) => {
              if (tag.id === tag.name) {
                return { id: null, name: tag.name };
              } else {
                return tag;
              }
            });
            this.props.selectHandler(mappedTags);
          }
        },
      );
    }
  };

  render() {
    return (
      <div className={'react-tag-selector'}>
        <ReactSelector
          isReadOnly={this.props.isReadOnly}
          onUpdateTags={this.handleUpdateTags}
          options={this.state.optionTypes}
          preSelected={this.state.selectedTags}
          menuPortalTarget={this.props.menuPortalTarget}
          focus={this.props.focus}
        />
      </div>
    );
  }
}
